import { OrderApi } from '../../generated/api';
import configuration from './configuration';

export default new OrderApi(configuration);
